'use client'
import { Box, CircularProgress } from '@mui/material'
import { useLocale } from 'next-intl'

import { useGetOfferDetailQuery } from '@/src/api/rtkQuery/offersApi'
import OfferDetailWrapper from '@/src/components/pages/offerDetail'

interface OfferDetailClientProps {
    offerSlug: string
}

/**
 * Client-side component that fetches and renders a single offer detail
 * using RTK Query. Can be used anywhere a single offer needs to be
 * displayed (e.g. drawers, modals, inline views).
 */
const OfferDetailClient: React.FC<OfferDetailClientProps> = ({ offerSlug }) => {
    const locale = useLocale()
    const { data: offer, isLoading, isError } = useGetOfferDetailQuery({ offerSlug, locale })

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress />
            </Box>
        )
    }

    if (isError || !offer) {
        const errorOffer = {
            offerId: offerSlug,
            title: '',
            description: '',
            imageUrl: '',
            error: true
        }
        return <OfferDetailWrapper offer={errorOffer} locale={locale} hideBookNow />
    }

    return <OfferDetailWrapper offer={offer} locale={locale} hideBookNow />
}

export default OfferDetailClient

